import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Data from '@/store/modules/data'
import Auth from '@/store/modules/auth'
import Affiliate from '@/store/modules/affiliate'
import Application from '@/store/modules/application'
import Wizard from '@/store/modules/wizard'

import { getModule } from 'vuex-module-decorators'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  modules: {
    Data,
    Auth,
    Affiliate,
    Application,
    Wizard
  }
})

export default store

export const DataModule = getModule(Data, store)
export const AuthModule = getModule(Auth, store)
export const AffiliateModule = getModule(Affiliate, store)
export const ApplicationModule = getModule(Application, store)
export const WizardModule = getModule(Wizard, store)
